import api from "./base";

export interface ImpersonatableUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isStaff: boolean;
  isSuperuser: boolean;
  companyName: string | null;
  position: string | null;
}

export const fetchImpersonatableUsers = (q?: string) =>
  api
    .get<{ results: ImpersonatableUser[] }>("impersonate/users/", {
      params: q ? { q } : undefined,
    })
    .then((r) => r.data.results);

export interface ImpersonateResponse {
  authToken: string;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    isStaff: boolean;
    isSuperuser: boolean;
    companyName: string | null;
  };
  impersonatedBy: string;
  /** Proof for IMPERSONATION_HEADER (api/base.ts); null when the server's audit write failed. */
  impersonation: string | null;
}

export const impersonateUser = (userId: string) =>
  api
    .post<ImpersonateResponse>("impersonate/", { user_id: userId })
    .then((r) => r.data);
